import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "@/store";

const initialState: IPatientUser = {
    ic_passport: "",
    id: "",
    name: "",
    username: "",
    email: "",
    phone: "",
    role: { role: "", role_id: "" },
    role_id: "",
    role_name: "",
    status: "",
    mmc: null,
    facilities: [],
    viewName: "",
    patient: {
        id: "",
        email: "",
        ic_passport: "",
        name: "",
        nationality: "",
        next_of_kin: "",
        nok_phone: "",
        nok_email: "",
        nok_relationship: "",
        patient_id: "",
        phone: "",
        user_id: "",
        username: "",
        patient_status: "",
        dob: "",
        street_address: "",
        city: "",
        residential_state: "",
        postcode: "",
        gender: "",
        ethnicity: "",
    },
    last_login: null,
};

const patientSlice = createSlice({
    name: "patient",
    initialState,
    reducers: {
        setPatient: (state, action: PayloadAction<IPatientUser | undefined>) => {
            const newPatient = action.payload ? action.payload : initialState;
            Object.assign(state, newPatient);
        },
    },
});

export const { setPatient } = patientSlice.actions;
export default patientSlice.reducer;

export const getPatient = (state: RootState) => state.patient;
export const getPatientFacilityId = (state: RootState) => state.patient.facilities?.[0]?.facility_id;
export const selectIsPatientWithinFacility = (state: RootState) =>
    state.user.facilities?.[0]?.facility_id === state.patient.facilities?.[0]?.facility_id;
